import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "../Logo";

export default function Footer() {
  return (
    <footer className="bg-navy text-white/70 mt-20">
      <div className="max-w-6xl mx-auto px-5 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Logo size={34} dark />
            <p className="text-sm mt-4 max-w-xs leading-relaxed">
              See what your money is committed to — before you spend what's left.
            </p>
          </div>
          <div>
            <p className="text-white text-sm font-medium mb-3">Product</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/how-it-works" className="hover:text-mint transition-colors">How It Works</Link></li>
              <li><Link to="/demo" className="hover:text-mint transition-colors">View Demo</Link></li>
              <li><Link to="/register" className="hover:text-mint transition-colors">Sign Up</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-white text-sm font-medium mb-3">Company</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-mint transition-colors">About</Link></li>
              <li><Link to="/contact" className="hover:text-mint transition-colors">Contact</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-white text-sm font-medium mb-3">Legal</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="hover:text-mint transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-mint transition-colors" data-testid="footer-terms-link">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row justify-between gap-3 text-xs">
          <p>© {new Date().getFullYear()} COMMITMENTT. Early access.</p>
          <p>Not a bank. Not financial advice. No bank credentials required.</p>
        </div>
      </div>
    </footer>
  );
}
